var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 34.3158V8.83333C5 6.99238 6.49238 5.5 8.33333 5.5H31.6667C33.5077 5.5 35 6.99238 35 8.83333V25.5C35 27.341 33.5077 28.8333 31.6667 28.8333H13.2687C12.2561 28.8333 11.2984 29.2937 10.6658 30.0843L6.78087 34.9405C6.19035 35.6787 5 35.2612 5 34.3158Z",
    fill: "#00A988",
    stroke: "#00A988",
    strokeWidth: 2.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.1665H14.1667C13.2462 17.1665 12.5 16.4203 12.5 15.4998V13.8332C12.5 12.9127 13.2462 12.1665 14.1667 12.1665H15.8333C16.7538 12.1665 17.5 12.9127 17.5 13.8332V17.1665ZM17.5 17.1665C17.5 18.8332 15.8333 20.4998 14.1667 22.1665L17.5 17.1665Z",
    fill: "#A6FF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.1665H14.1667C13.2462 17.1665 12.5 16.4203 12.5 15.4998V13.8332C12.5 12.9127 13.2462 12.1665 14.1667 12.1665H15.8333C16.7538 12.1665 17.5 12.9127 17.5 13.8332V17.1665ZM17.5 17.1665C17.5 18.8332 15.8333 20.4998 14.1667 22.1665",
    stroke: "#A6FF00",
    strokeWidth: 2.3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 17.1665H24.1667C23.2462 17.1665 22.5 16.4203 22.5 15.4998V13.8332C22.5 12.9127 23.2462 12.1665 24.1667 12.1665H25.8333C26.7538 12.1665 27.5 12.9127 27.5 13.8332V17.1665ZM27.5 17.1665C27.5 18.8332 25.8333 20.4998 24.1667 22.1665L27.5 17.1665Z",
    fill: "#A6FF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 17.1665H24.1667C23.2462 17.1665 22.5 16.4203 22.5 15.4998V13.8332C22.5 12.9127 23.2462 12.1665 24.1667 12.1665H25.8333C26.7538 12.1665 27.5 12.9127 27.5 13.8332V17.1665ZM27.5 17.1665C27.5 18.8332 25.8333 20.4998 24.1667 22.1665",
    stroke: "#A6FF00",
    strokeWidth: 2.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.ec62c6b317099c20fb19144bc360ca4a.svg";
export { ForwardRef as ReactComponent };